import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { useEffect, useState } from 'react'

const UnpublishedShiftConfirmDialog = ({
  summary,
  isSubmitting,
  onCancel,
  onConfirm,
}) => {
  const [isConfirmed, setIsConfirmed] = useState(false)

  useEffect(() => {
    setIsConfirmed(false)
  }, [summary])

  const footer = (
    <div>
      <Button
        type='button'
        label='キャンセル'
        icon='pi pi-times'
        className='p-button-secondary'
        disabled={isSubmitting}
        onClick={onCancel}
      />
      <Button
        type='button'
        label='登録を確定する'
        icon={`pi pi-${isSubmitting ? 'spinner pi-spin' : 'check'}`}
        disabled={!isConfirmed || isSubmitting}
        onClick={onConfirm}
      />
    </div>
  )

  return (
    <Dialog
      header='未掲載シフトの登録確認'
      visible={!!summary}
      footer={footer}
      closable={!isSubmitting}
      onHide={onCancel}
      style={{ width: '520px', maxWidth: 'calc(100vw - 32px)' }}
    >
      {summary && (
        <div>
          <dl style={{ marginTop: 0 }}>
            <dt style={{ fontWeight: 'bold' }}>未掲載で作成される件数</dt>
            <dd style={{ margin: '4px 0 16px' }}>{summary.count}件</dd>
            <dt style={{ fontWeight: 'bold' }}>対象勤務日</dt>
            <dd style={{ margin: '4px 0 16px' }}>
              {summary.earliestDate} ～ {summary.latestDate}
            </dd>
          </dl>
          <p style={{ lineHeight: 1.7 }}>
            未掲載の場合、医師への確定通知メールは送信されず、
            <br />
            自動的に掲載へ変更されません。
            <br />
            登録後に掲載状態をご確認ください。
          </p>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}>
            <Checkbox
              inputId='confirm-unpublished-shift-upload'
              checked={isConfirmed}
              onChange={event => setIsConfirmed(event.checked)}
            />
            <label
              htmlFor='confirm-unpublished-shift-upload'
              style={{ marginLeft: 8 }}
            >
              未掲載で登録されることを確認しました
            </label>
          </div>
        </div>
      )}
    </Dialog>
  )
}

export default UnpublishedShiftConfirmDialog
